var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilBuildings } from "../../utils/utilBuildings";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { MenuInfoContentNonProductionDOM } from "./MenuInfoContentNonProductionDOM";
import { MenuInfoContentProductionDOM } from "./MenuInfoContentProductionDOM";
var MenuInfoBuildingDOM = /** @class */ (function (_super) {
    __extends(MenuInfoBuildingDOM, _super);
    function MenuInfoBuildingDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuInfoBuildingDOM.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.building !== undefined;
    };
    MenuInfoBuildingDOM.prototype.render = function () {
        var _a = this.props, building = _a.building, onClose = _a.onClose;
        var buildingStage = utilBuildings.getBalancingStage(building);
        var content = React.createElement(MenuInfoContentNonProductionDOM, { building: building });
        if (buildingStage && buildingStage.recipeIDs) {
            content = React.createElement(MenuInfoContentProductionDOM, null);
        }
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.overview, onClose: onClose, className: IdStyles.ModalBackgroundInfo }, content));
    };
    return MenuInfoBuildingDOM;
}(React.Component));
var mapState = function (state) { return ({
    building: state.playerBase.buildings.building,
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.BuildingInfo)); },
}); };
export var MenuInfoBuilding = connect(mapState, mapDispatch)(MenuInfoBuildingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info-menu/MenuInfoBuilding.tsx
// module id = 2840
// module chunks = 3